export default [
	{
		name:'订单号',
		Display:'订单号',
		type:1
	},
	{
		name:'版本号',
		Display:'版本号',
		type:1
	},
	{
		name:'发出日期_from',
		Display:'文件发出日期起',
		dateTime:{
			format:'yyyyMMdd',
			type:'date'
		},
		type:3
	},
	{
		name:'发出日期_to',
		Display:'文件发出日期止',
		dateTime:{
			format:'yyyyMMdd',
			type:'date'
		},
		type:3
	},
	{
		name:'工厂号',
		Display:'工厂号',
		type:1
	},
	
]

export const detailFilter=[
	{
		name:'零件号',
		Display:'零件号',
		type:2,
		dataSource:[],
		valueName:'零件号',
		displayName:'零件号'
	}
]